import React, { useEffect, useRef, useState } from "react";
import { Typography, Button } from "@mui/material";

import FileUpload from "../FileUploader/FileUpload";

import ProductInfoModal from "./ProductInfoModal";
import SidebarDetails from "../scripts/SidebarDetails/SidebarDetails";

import { useNavigate, useParams } from "react-router-dom";
import ScriptAccordion from "./ScriptAccordion/ScriptAccordion";
import AddScriptBanner from "../crm/AddScriptBanner";
import fetchWithAuth from "../../util/fetchWithAuth";
import { API_URL } from "../../util/url";
import useFetchWithAuth from "../../features/hooks/useFetchWithAuth";
import {
  prepareAccordionItems,
  preparePatchPayload,
  toFormData,
} from "../../features/scripts";

export default function EditableScriptDetails({ onSuccess }) {
  const { scriptId: id } = useParams();

  const [attributes, setAttributes] = useState([]);
  const [selectedAttrIndex, setSelectedAttrIndex] = useState(null);
  const [quantity, setQuantity] = useState();
  const [items, setItems] = useState([]);

  const modalRef = useRef(null);
  const [modalType, setModalType] = useState(null);

  const [newCategoryName, setNewCategoryName] = useState("");
  const [newScriptText, setNewScriptText] = useState("");
  const [file, setFile] = useState();

  const navigate = useNavigate();

  const { data, error, loading, refetch } = useFetchWithAuth(
    `/scripts/products/${id}`,
    {
      method: "GET",
    }
  );
  const onFileSelect = (files) => {
    if (files && files.length > 0) {
      setFile(files[0]);
    }
  };
  const handleOpenModal = (type) => setModalType(type);
  const handleCloseModal = () => setModalType(null);

  const onConfirm = async () => {
    const payload = preparePatchPayload(items, quantity, attributes, data);
    console.log("PATCH payload:", payload);

    // Преобразуем в FormData
    const formData = toFormData({ ...payload, image: file });
    console.log(formData);
    try {
      const res = await fetchWithAuth(`${API_URL}/scripts/products/${id}/`, {
        method: "PATCH",
        body: formData,
      });

      if (!res.ok) throw new Error("Ошибка при обновлении");
      const updated = await res.json();

      console.log("Успешно обновлено:", updated);
      refetch();
      setModalType(null);
    } catch (err) {
      console.error(err);
    }
  };

  const openAttributeList = () => setModalType("attribute_list");

  const handleAddScript = () => {
    if (!newCategoryName || !newScriptText) return;

    setItems((prev) => [
      ...prev,
      {
        id: Date.now(),
        category: newCategoryName,
        scripts: [newScriptText],
      },
    ]);

    setNewCategoryName("");
    setNewScriptText("");
  };

  const onSubmitEdit = (updatedItem) => {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.scripts && item.id === updatedItem.id
          ? {
              ...item,
              category: updatedItem.title,
              scripts: updatedItem.scripts,
            }
          : item
      )
    );

    setModalType(null);
  };

  useEffect(() => {
    if (!data) return;

    setQuantity(data.total_quantity || 0);

    setAttributes(
      data.attributes.map((attr) => ({
        name: attr.name,
        variations: attr.values.map((v) => v.value),
      }))
    );

    const prepared = prepareAccordionItems(data);
    setItems(prepared);

    setQuantity(data?.quantity || 0);
  }, [data]);

  if (loading) return null;
  if (!data) return null;

  return (
    <>
      <SidebarDetails
        id={data.id}
        title={data.title || "Без названия"}
        price={data.price ? `$${data.price}` : "—"}
        productName={data.title}
        imageComponent={<FileUpload onFileSelect={onFileSelect} />}
        bannerActions={
          <>
            <Button
              variant="contained"
              className="btn btn-primary"
              sx={{ borderRadius: "15px", textTransform: "none" }}
              onClick={onConfirm}
            >
              <Typography variant="subtitle2">Відправити</Typography>
            </Button>
          </>
        }
        actionComponent={
          <>
            <Button variant="outlined" onClick={openAttributeList}>
              Додати атрибут
            </Button>
            <Button variant="text" onClick={() => handleOpenModal("quantity")}>
              + Кількість
            </Button>
          </>
        }
      />
      <AddScriptBanner
        onClose={() => {}}
        categoryName={newCategoryName}
        setCategoryName={setNewCategoryName}
        scriptText={newScriptText}
        setScriptText={setNewScriptText}
        onSave={handleAddScript}
      />
      {/* Accordion */}
      <ScriptAccordion
        items={items}
        onClick={(id) => console.log(id)}
        onSubmitEdit={onSubmitEdit}
        onDeleteScriptText={(itemId) => {
          setItems((prevItems) => {
            return prevItems.filter((item) => {
              return item.id !== itemId;
            });
          });
        }}
      />
      <ProductInfoModal
        open={Boolean(modalType)}
        onClose={handleCloseModal}
        modalType={modalType}
        modalRef={modalRef}
        attributes={attributes}
        setAttributes={setAttributes}
        selectedAttrIndex={selectedAttrIndex}
        setSelectedAttrIndex={setSelectedAttrIndex}
        setModalType={setModalType}
        setQuantity={setQuantity}
        quantity={quantity}
      />
    </>
  );
}
